module.exports = __webpack_public_path__ + "static/media/fsc7.e5f41baa.svg";